export default __webpack_public_path__ + "static/media/friesland_text_logo.7b55fb9d.svg";